var map = {
	"./corridor.png": "./src/images/NorthPoint/corridor.png",
	"./livingroom.png": "./src/images/NorthPoint/livingroom.png",
	"./wardrobe.png": "./src/images/NorthPoint/wardrobe.png",
	"./wc.png": "./src/images/NorthPoint/wc.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/NorthPoint sync recursive \\.(png%7Cjpe?g%7Csvg)$";